import { Element } from "@craftjs/core";
import { Box } from "components/ui";
import React from "react";
import { PageContainer } from "./PageContainer";

export const AccordionListTitle = ({ ...props }) => {
	return <Box {...props} />;
};

export const AccordionListLocation = ({ children, ...props }: any) => {
	return (
		<Box
			{...props}
			style={{
				padding: "10px",
				marginBottom: "10px",
				borderBottom: "1px solid #eee",
				display: "flex",
				flexDirection: "column",
				alignItems: "flex-start",
				gap: "6px",
			}}
		>
			{children}
		</Box>
	);
};

export const PageAccordion = ({ background, ...props }: { background?: string; [key: string]: any }) => {
	return (
		<PageContainer background={background || "white"} padding={20}>
			<div {...props}>
				<Element id="listing-title" is={AccordionListTitle} data-cy="testimonial-list-title"></Element>
				<Element canvas id="testimonial-drop-location" is={AccordionListLocation} data-cy="testimonial-drop-location"></Element>
			</div>
		</PageContainer>
	);
};
